<template>
  <layout-main-inner title="行业管理">
    <el-button
      slot="action"
      type="primary"
      @click="additem">
      新增一级分类
    </el-button>
    <layout-card-wrap>
      <!-- <template slot="form">
        <el-input
          v-model="config.quarantineName"
          clearable
          placeholder="请输入分类名称"
          @clear="handleCurrentChange(1)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template> -->
      <el-table
        border
        row-key="classId"
        default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :data="list"
      >
        <el-table-column
          label="分类名称"
          prop="className">
          <!-- <template slot-scope="{ row }">
            <link-route
              :link-to="`/categorydetail?quarantineCode=${row.quarantineCode}`"
            >
              {{ row.className }}
            </link-route>
          </template> -->
        </el-table-column>
        <!-- <el-table-column
          label="分类编码"
          width="130"
          prop="quarantineCode">
        </el-table-column> -->
        <!-- <el-table-column
          label="更新时间"
          width="130">
          <template slot-scope="{ row }">
            <span>{{ row.updatedTime | dateformat() }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          width="260">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">
              编辑
            </el-button>
            <el-button
              type="danger"
              @click="deleteitem(row)">
              删除
            </el-button>
            <el-button
              v-if="row.level === 1"
              type="primary"
              @click="additem(row)"
            >
              创建二级分类
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination> -->
    </layout-card-wrap>
    <edit-category-modal
      ref="category"
      :callback="
        () => {
          getlist();
        }
      "
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditCategoryModal from './editCategoryModal.vue'

export default {
  name: 'CategorysIndex',
  components: { EditCategoryModal },
  data() {
    return {
      loading: true,
      list: [],
      // totalNum: 0,
      config: {
        // pageNum: 1,
        // pageSize: 10,
        // quarantineName: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      this.$refs.category.update(row)
    },
    additem(row) {
      this.$refs.category.add(row)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该产品分类?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletecategory', {
          payload: {
            classId: row.classId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    // handleCurrentChange(val) {
    //   this.config.pageNum = val
    //   this.getlist()
    // },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getcategorytree', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          // this.totalNum = res.data.total
          this.list = res.data.categorys
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
